module.exports = __webpack_public_path__ + "img/next-svgrepo-com.343a346f.svg";